import {
  GET_EMPLOYEEASSESSMENTDETAIL,
  GET_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  GET_EMPLOYEEASSESSMENTDETAIL_FAIL,
  DELETE_EMPLOYEEASSESSMENTDETAIL,
  DELETE_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  DELETE_EMPLOYEEASSESSMENTDETAIL_FAIL,
  UPDATE_EMPLOYEEASSESSMENTDETAIL,
  UPDATE_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  UPDATE_EMPLOYEEASSESSMENTDETAIL_FAIL,
  ADD_NEW_EMPLOYEEASSESSMENTDETAIL,
  ADD_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  ADD_EMPLOYEEASSESSMENTDETAIL_FAIL,
  EMPLOYEEASSESSMENTDETAIL_LOADING,
  EMPLOYEEASSESSMENTDETAIL_RESET,
} from "./actionType";

export const resetEmployeeAssessmentDetailState = (actionType) => ({
  type: EMPLOYEEASSESSMENTDETAIL_RESET,
  payload: { actionType },
});

export const getEmployeeAssessmentDetailSuccess = (actionType, data) => ({
  type: GET_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getEmployeeAssessmentDetailFail = (actionType, error) => ({
  type: GET_EMPLOYEEASSESSMENTDETAIL_FAIL,
  payload: { actionType, error },
});

export const getEmployeeAssessmentDetail = data => ({
  type: GET_EMPLOYEEASSESSMENTDETAIL,
  payload: data,
});

export const getEmployeeAssessmentDetailLoading = () => ({
  type: EMPLOYEEASSESSMENTDETAIL_LOADING
});

export const deleteEmployeeAssessmentDetail = data => ({
  type: DELETE_EMPLOYEEASSESSMENTDETAIL,
  payload: data,
});

export const deleteEmployeeAssessmentDetailSuccess = data => ({
  type: DELETE_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  payload: data,
});

export const deleteEmployeeAssessmentDetailFail = error => ({
  type: DELETE_EMPLOYEEASSESSMENTDETAIL_FAIL,
  payload: error,
});

export const updateEmployeeAssessmentDetail = data => ({
  type: UPDATE_EMPLOYEEASSESSMENTDETAIL,
  payload: data,
});

export const updateEmployeeAssessmentDetailFail = error => ({
  type: UPDATE_EMPLOYEEASSESSMENTDETAIL_FAIL,
  payload: error,
});

export const updateEmployeeAssessmentDetailSuccess = data => ({
  type: UPDATE_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  payload: data,
});

export const addNewEmployeeAssessmentDetail = data => ({
  type: ADD_NEW_EMPLOYEEASSESSMENTDETAIL,
  payload: data,
});

export const addEmployeeAssessmentDetailSuccess = data => ({
  type: ADD_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  payload: data,
});

export const addEmployeeAssessmentDetailFail = error => ({
  type: ADD_EMPLOYEEASSESSMENTDETAIL_FAIL,
  payload: error,
});